export default __webpack_public_path__ + "static/media/gt.8c4469d4.svg";